import axios from 'axios'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function configurarCieloLinkEmpresa(empresaId, dados) {
  const url = `${URL}/empresas/${empresaId}/configurar-cielo-link`;
  return () => axios.post(url, dados, SLOW_REQUEST_CONFIG);
}
